'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _enemies = require('./actors/enemies');

var _loop = function _loop(_key7) {
  if (_key7 === "default") return 'continue';
  Object.defineProperty(exports, _key7, {
    enumerable: true,
    get: function get() {
      return _enemies[_key7];
    }
  });
};

for (var _key7 in _enemies) {
  var _ret = _loop(_key7);

  if (_ret === 'continue') continue;
}

var _score = require('./actors/score');

var _loop2 = function _loop2(_key8) {
  if (_key8 === "default") return 'continue';
  Object.defineProperty(exports, _key8, {
    enumerable: true,
    get: function get() {
      return _score[_key8];
    }
  });
};

for (var _key8 in _score) {
  var _ret2 = _loop2(_key8);

  if (_ret2 === 'continue') continue;
}

var _shots = require('./actors/shots');

var _loop3 = function _loop3(_key9) {
  if (_key9 === "default") return 'continue';
  Object.defineProperty(exports, _key9, {
    enumerable: true,
    get: function get() {
      return _shots[_key9];
    }
  });
};

for (var _key9 in _shots) {
  var _ret3 = _loop3(_key9);

  if (_ret3 === 'continue') continue;
}

var _spaceship = require('./actors/spaceship');

var _loop4 = function _loop4(_key10) {
  if (_key10 === "default") return 'continue';
  Object.defineProperty(exports, _key10, {
    enumerable: true,
    get: function get() {
      return _spaceship[_key10];
    }
  });
};

for (var _key10 in _spaceship) {
  var _ret4 = _loop4(_key10);

  if (_ret4 === 'continue') continue;
}

var _asteroids = require('./actors/asteroids');

var _loop5 = function _loop5(_key11) {
  if (_key11 === "default") return 'continue';
  Object.defineProperty(exports, _key11, {
    enumerable: true,
    get: function get() {
      return _asteroids[_key11];
    }
  });
};

for (var _key11 in _asteroids) {
  var _ret5 = _loop5(_key11);

  if (_ret5 === 'continue') continue;
}

var _planets = require('./actors/planets');

var _loop6 = function _loop6(_key12) {
  if (_key12 === "default") return 'continue';
  Object.defineProperty(exports, _key12, {
    enumerable: true,
    get: function get() {
      return _planets[_key12];
    }
  });
};

for (var _key12 in _planets) {
  var _ret6 = _loop6(_key12);

  if (_ret6 === 'continue') continue;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJhY3RvcnMuanMiLCJzb3VyY2VzQ29udGVudCI6W119